var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "reset-to-default-props": _vm.resetToDefaultProps,
                  "set-default-props": _vm.setDefaultProps,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: _vm.$v.$invalid,
                  }),
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "reset-to-default": _vm.handleResetToDefault,
                  "set-default": _vm.handleSetDefault,
                  "run-report": _vm.handleRunReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading || _vm.localLoading
        ? _c("application-summary-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: { "selected-level": _vm.settings.level },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(_vm.settings, "level", $event)
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(_vm.settings, "level", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                { staticClass: "form-title font-sm mb-0" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.$tc("global.doorr.agent", 1)
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _c("input-required-indicator"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("agents-select", {
                                ref: "agentsSelect",
                                attrs: {
                                  id: "select-agents-reports",
                                  value: _vm.settings.agents,
                                  "default-value": _vm.settings.agents,
                                  "select-options": _vm.options,
                                  label: "",
                                  "has-checkboxes": "",
                                  "space-classes":
                                    "form-group-material form-group-material-no-label",
                                  "extra-select-data": _vm.selectAllOption,
                                  "close-on-select-all": "",
                                },
                                on: { change: _vm.handleSelectAgentChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format": _vm.settings.format,
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(_vm.settings, "format", $event)
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(_vm.settings, "format", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.doorr.lender")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-lender", {
                            attrs: {
                              "selected-lender": _vm.settings.lender,
                              multiple: "",
                              "default-value": _vm.settings.lender,
                              action: _vm.action,
                              clearable: true,
                            },
                            on: {
                              "update:selectedLender": function ($event) {
                                return _vm.$set(_vm.settings, "lender", $event)
                              },
                              "update:selected-lender": function ($event) {
                                return _vm.$set(_vm.settings, "lender", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationStatus"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm.atLeastOneSelectedTypeAndLender
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-application-status", {
                            ref: "applicationStatusSelect",
                            attrs: {
                              "selected-application-status":
                                _vm.settings.applicationStatus,
                              action: _vm.action,
                              clearable: true,
                              multiple: "",
                            },
                            on: {
                              "update:selectedApplicationStatus": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.settings,
                                  "applicationStatus",
                                  $event
                                )
                              },
                              "update:selected-application-status": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.settings,
                                  "applicationStatus",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm.atLeastOneSelectedStatusAndLender
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: {
                                id: "select-application-type-search",
                                "no-label": "",
                                label: _vm.$t("global.words.search"),
                                "hidden-label": true,
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass:
                                  "search-input w-100 vsSelectedCheckboxes",
                                attrs: {
                                  options: _vm.selectsData.applicationType,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  label: "text",
                                  clearable: "",
                                  "default-value": _vm.settings.applicationType,
                                  multiple: "",
                                  "has-checkboxes": "",
                                  "deselect-from-dropdown": "",
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected":
                                    _vm.handleChangeApplicationType,
                                  "option:deselected":
                                    _vm.handleChangeApplicationType,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", sm: "6", lg: "12" } },
                        [
                          _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("application-reports.referralSource")
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12", lg: "6" } },
                                [
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-referral-source",
                                        "no-label": "",
                                      },
                                    },
                                    [
                                      _c("referrers-select", {
                                        ref: "referrersSelect",
                                        attrs: {
                                          "allow-create": false,
                                          "allow-clear": "",
                                          action: _vm.action,
                                          label: "",
                                          "space-classes": "",
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          "no-label": "",
                                          multiple: "",
                                          "has-checkboxes": true,
                                          "extra-select-data":
                                            _vm.selectAllOption,
                                          "default-referrers":
                                            _vm.defaultReferrers,
                                        },
                                        on: {
                                          change:
                                            _vm.handleChangeReferralSource,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.dateType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-date-type", "no-label": "" },
                              model: {
                                value: _vm.settings.dateType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "dateType", $$v)
                                },
                                expression: "settings.dateType",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.selectsData.dateType,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.settings.dateType,
                                  clearable: false,
                                  label: "text",
                                  "default-value": _vm.settings.dateType,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function (ref) {
                                    var id = ref.id

                                    return (_vm.settings.dateType = id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.dateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date": _vm.settings.dateTo,
                                        },
                                        model: {
                                          value: _vm.settings.dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression: "settings.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date": _vm.settings.dateFrom,
                                        },
                                        model: {
                                          value: _vm.settings.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression: "settings.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.groupBy"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-group-by", "no-label": "" },
                              model: {
                                value: _vm.settings.groupBy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "groupBy", $$v)
                                },
                                expression: "settings.groupBy",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.selectsData.groupBy,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.settings.groupBy,
                                  clearable: false,
                                  label: "text",
                                  "default-value": _vm.settings.groupBy,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function (ref) {
                                    var id = ref.id

                                    return (_vm.settings.groupBy = id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.firstSortBy"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-1",
                                        "no-label": "",
                                      },
                                      model: {
                                        value: _vm.settings.sortByPrimary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.settings,
                                            "sortByPrimary",
                                            $$v
                                          )
                                        },
                                        expression: "settings.sortByPrimary",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.primaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value: _vm.settings.sortByPrimary,
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.settings.sortByPrimary,
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (ref) {
                                            var id = ref.id

                                            return (_vm.settings.sortByPrimary =
                                              id)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.secondSortBy"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-2",
                                        "no-label": "",
                                      },
                                      model: {
                                        value: _vm.settings.sortBySecondary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.settings,
                                            "sortBySecondary",
                                            $$v
                                          )
                                        },
                                        expression: "settings.sortBySecondary",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.secondaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value: _vm.settings.sortBySecondary,
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.settings.sortBySecondary,
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (ref) {
                                            var id = ref.id

                                            return (_vm.settings.sortBySecondary =
                                              id)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }